import ProfileImage from './ProfileImage.jsx';
import './ProfileImage.css';

export default ProfileImage;
